import { type Chains, enumChecker } from '@soundxyz/utils/const';
import { ChainType } from '@graphql/reactQuery/generated/types';

export const isChainType = enumChecker(ChainType);

export function expectChainType(chain: Chains): ChainType {
  if (!isChainType(chain)) throw Error(`Chain ${chain} still not supported on backend schema`);

  return chain;
}
